
export const loadData = <T>(key: string, defaultValue: T): T => {
  try {
    const localData = localStorage.getItem(key);
    if (localData !== null) {
      return JSON.parse(localData) as T;
    }
    return defaultValue;
  } catch (error) {
    console.error('Error loading data from localStorage:', error);
    return defaultValue;
  }
};

export const saveLocalData = (key: string, data: any): void => {
  localStorage.setItem(key, JSON.stringify(data));
};
